import { parseDataValidationErrors } from './parseDataValidationErrors';

/**
 * Handles an error from a service call: maps data validation errors to inline form fields,
 * renders the NotFound view on 404, shows a toast message, and calls an optional callback.
 * @param {{ err: unknown, showMessage: Function, setSideDialog?: Function, setNotFound?: Function }} options
 * @param {Function} [callback] - Optional callback invoked with the error after messaging.
 */
export const handleError = ({ err, showMessage, setSideDialog, setNotFound }, callback) => {
  if (err) {
    try {
      if (err.name && err.name === 'AbortError') {
        return; // Request has been canceled, so do nothing
      }

      if (err.dataValidationError && setSideDialog) {
        setSideDialog(prev => ({
          ...prev,
          formErrors: parseDataValidationErrors(err.dataValidationError),
        }));
      }

      // Render the NotFound view instead of a toast when the resource does not exist.
      if (err.status === 404 && setNotFound) {
        setNotFound(true);
        return;
      }

      showMessage && showMessage(err, 'error');
      callback && callback(err);
    } catch (e) {
      throw e;
    }
  }
};
